import _ from "lodash";
import store from "@/store";
import router from "@/router";
import moment from "moment";
import CryptoJS from "@/assets/js/cipherUtils.js";

const axios = require("axios").default;
const cryptoURI = ["/auth/motp/issunc/RBF0404B40", "/auth/motp/common/sendCetrNoConfirm"];

//로컬일때만 적용
if (document.location.host.indexOf(`web.${process.env.VUE_APP_DOMAIN}`) > -1) {
  if (process.env.VUE_APP_API_CALL == "rca") {
    axios.defaults.baseURL = `${process.env.VUE_APP_SERVER_PROTOCOL}://${process.env.VUE_APP_SERVER_DOMAIN}`;
  }
}

const requestOptions = {
  timeout: 1000 * 60 * 5,
};
//axios common before
axios.interceptors.request.use(
  function (config) {
    let addHeaders = {};

    if (config.url.includes("/customer/aprv/OtrbnkQtExcelUpload")) {
      addHeaders = {
        "Content-Type": "multipart/form-data",
      };
      config.headers = _.merge(config.headers, addHeaders);
    } else if (!config.url.includes("/nppfs.servlet.do") && config.method != "get") {
      // 키보드 보안 초기화 URL은 파라미터 변경 예외.
      let paramData = {
        Scrno: "REA7533B000", //화면번호 - 삭제
        Task: {
          bzwkCmnDvsn: {
            operGroupCd: "", //운영그룹코드
            brnCd: "", //지점코드
            bzwkGroupCd: "", //
          },
          inItem: config.data,
        },
      };

      //키패드
      paramData.Task._nprotected = config.data._nprotected;
      if (paramData.Task.inItem.hasOwnProperty("array")) {
        paramData.Task.inItem = config.data.array;
      } else {
        delete paramData.Task.inItem._nprotected;
      }

      config.data = paramData;
      addHeaders = {
        "Content-Type": "application/json; charset=UTF-8",
      };
      config.headers = _.merge(config.headers, addHeaders);
    }

    if (config.url.includes("/nppfs.servlet.do")) {
      addHeaders = {
        common: { Accept: "application/json, text/plain, */*" },
        delete: {},
        get: {},
        head: {},
        patch: { "Content-Type": "application/x-www-form-urlencoded" },
        post: { "Content-Type": "application/x-www-form-urlencoded" },
        put: { "Content-Type": "application/x-www-form-urlencoded" },
      };
      config.headers = _.merge(config.headers, addHeaders);
    }

    config.withCredentials = true;

    return config;
  },
  function (e) {
    return Promise.reject(e);
  },
);

//axios.interceptors.response

export default {
  install(Vue) {
    Vue.prototype.$get = function (callUrl, postData) {
      axios.get(localApiPort(callUrl), { responseType: "arraybuffer", headers: { "Content-Type": "application/json", Accept: "application/pdf" } }).then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        // link.setAttribute("download", "terms.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    };
    /**
     * API call
     */
    Vue.prototype.$post = function (callUrl, postData, succ, fail, final = null, autoErrorShow, autoLoadingShow) {
      // call function
      const apiCall = function (callUrl, postData, succ, fail, final = null, thisObj, autoErrorShow, autoLoadingShow) {
        //오류 초기화
        store.state.error = {
          active: false,
          errCode: "",
          errMsg: "",
          type: "page",
        };

        //로딩바 show
        if (autoLoadingShow) {
          store.dispatch("actSetLoading", true);
        }

        let siteCode = store.state.siteCode;
        if (siteCode == Vue.prototype.$config.SITECODE_OGHCM) {
          siteCode = "oghcm";
        }

        //공통헤더
        axios.defaults.headers = {
          "X-Rca-Client-Info": `{siteCode:'${siteCode}', natCode:'${store.state.lang}', Scrno: 'REA7533B000', channelsubid:'43'}`,
        };

        const timeNow = moment().format("YYYYMMDDHHmmssSSS");

        axios
          .post(localApiPort(callUrl), postData, {
            ...requestOptions,
            transformRequest: [
              data => {
                if (cryptoURI.includes(callUrl)) {
                  data.Task.bzwkCmnDvsn = {
                    ...data.Task.bzwkCmnDvsn,
                    timeStamp: timeNow, //타임스템프
                  };

                  data.Task = CryptoJS.encrypt(data.Task);
                }
                return JSON.stringify(data);
              },
            ],
          })
          .then(result => {
            thisObj.$log.debug(URL, JSON.stringify(postData));
            thisObj.$log.debug(result.data);
            let data = result.data;

            if (cryptoURI.includes(callUrl)) {
              if (!_.isEmpty(data.Device.ErrmsgErrcd)) {
                store.state.error.active = true;
                store.state.error.errCode = data.Device.ErrmsgErrcd;
                store.state.error.errMsg = data.Device.ErrmsgOutptCstzMsgCtnt;
                if (typeof fail == "function") fail(data.Device);
                return;
              }

              let device = CryptoJS.decrypt(data.Device);
              if (device.bzwkCmnDvsn.timeStamp == CryptoJS.getHash(timeNow)) {
                thisObj.$log.info("TO-DO ");
                data.Device = device;
              } else {
                store.state.error.active = true;
                store.state.error.errCode = "RCA00004";
                store.state.error.errMsg = "msg";
                if (typeof fail == "function") fail(data.Device);
                return;
              }
            }

            try {
              if (data.Device.ErrmsgErrcd) {
                // 서버는 비로그인 상태 && 로그인 거래인 경우..
                if ("CAQ50001|B99Z0002|B14A7002".includes(data.Device.ErrmsgErrcd)) {
                  if (store.state.sessionInfo.isLogin) {
                    store.state.autoLogout = true;
                  }
                  store.dispatch("ACT_EXEC_LOGOUT");
                  // if (process.env.NODE_ENV == "development") {
                  //   alert(`${siteCode}/${callUrl}/${data.Device.ErrmsgErrcd}`);
                  // }
                  return;
                }
                if (autoErrorShow) {
                  store.state.error.active = true;
                }
                store.state.error.errCode = data.Device.ErrmsgErrcd;
                store.state.error.errMsg = data.Device.ErrmsgOutptCstzMsgCtnt ? data.Device.ErrmsgOutptCstzMsgCtnt : data.Device.TreatDesc;

                if (typeof fail == "function") fail(data.Device);
              } else {
                if (typeof succ == "function") succ(data.Device, data.Task);
              }
            } catch (error) {
              thisObj.$log.error(error);
              store.state.error.active = true;
              store.state.error.errCode = "RCA99999";
              store.state.error.errMsg = _.get(error, "message");
              if (typeof fail == "function") fail(data.Device);
            }
          })
          .catch(e => {
            thisObj.$log.error(e);
            if (typeof fail == "function") fail(e);
            router.push({ name: "errorPage", params: { code: "RCA99999", msg: _.get(e, "message"), type: thisObj.$config.ERROR_NETWORK } });
          })
          .then(() => {
            //always
            if (autoLoadingShow) {
              store.dispatch("actSetLoading", false);
            }
            if (typeof final == "function") final();
          });
      };

      // 인증 공통 처리 commAuth = { biz: "", bizParam: { amt: "" } }
      if (!_.isNil(postData.commAuth)) {
        // 추가인증 후 거래
        this.$store.dispatch("common/supplCertn/act001supplCertn", {
          callUrl: callUrl,
          postData: postData,
          succ: succ,
          fail: fail,
          final: final,
          autoErrorShow: true,
          autoLoadingShow: true,
        });
      } else {
        // 일반거래
        apiCall(callUrl, postData, succ, fail, final, this, _.isNil(autoErrorShow) ? true : autoErrorShow, _.isNil(autoLoadingShow) ? true : autoLoadingShow);
      }
    };
  },
};

const localApiPort = callUrl => {
  const contextUrl = callUrl.split("/")[1];
  let port = "";
  switch (contextUrl) {
    case "account":
      port = "5051";
      break;
    case "auth":
      port = "5052";
      break;
    case "commonbiz":
      port = "5055";
      break;
    case "customer":
      port = "5056";
      break;
    case "deposit":
      port = "5057";
      break;
    case "intnfinac":
      port = "5059";
      break;
    case "loan":
      port = "5063";
      break;
    case "transfer":
      port = "5062";
      break;
  }
  let URL = "";

  //VUE_APP_API_CALL == local,  VUE_APP_SERVER_LOCAL+port번호+v2 추가
  //else 업무서비스명 앞에/v2 추가
  // ㄴ 개발/스테이징/운영
  const callUrl2 = "/v2" + callUrl;
  if (process.env.VUE_APP_API_CALL == "local") {
    URL = callUrl;
  } else {
    switch (process.env.NODE_ENV) {
      case "local":
        URL = callUrl;
        break;
      case "development":
        URL = callUrl;
        break;
      case "staging":
        URL = callUrl;
        break;
      case "production":
        URL = callUrl;
        break;
    }
  }

  return URL;
};
